import { getDownloadURL, ref, uploadBytesResumable, type FirebaseStorage } from 'firebase/storage';

export function sanitizeName(name: string): string {
  return name.replace(/[^A-Za-z0-9._ ()+\-]/g, '_').slice(0, 200);
}

export type UploadHandle = {
  promise: Promise<{ path: string; url: string; name: string }>;
  cancel: () => void;
};

/** Upload into uploads/{courseId}/{name}. Admin-only via storage rules. */
export function uploadFile(
  storage: FirebaseStorage,
  file: File,
  courseId: string,
  onProgress: (loaded: number, total: number) => void
): UploadHandle {
  const safeCourse = courseId.replace(/[^A-Za-z0-9_-]/g, '-').slice(0, 64) || 'general';
  const name = sanitizeName(file.name);
  const path = `uploads/${safeCourse}/${name}`;
  const r = ref(storage, path);
  const task = uploadBytesResumable(r, file, {
    contentType: file.type || 'application/octet-stream',
    customMetadata: { uploadedBy: 'hub-admin' }
  });
  return {
    promise: new Promise((resolve, reject) => {
      task.on(
        'state_changed',
        s => onProgress(s.bytesTransferred, s.totalBytes),
        reject,
        async () => {
          const url = await getDownloadURL(task.snapshot.ref);
          resolve({ path, url, name });
        }
      );
    }),
    cancel: () => {
      task.cancel();
    }
  };
}
